import {
  GET_UDEMY_COURSES,
  GET_UDEMY_COURSES_SUCCESS,
  GET_UDEMY_COURSES_FAILURE,
} from "../constants";

const initialState = {
  udemy: {},
  isUdemyLoading: false,
  error: null,
};

export default function InteractiveLearningReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case GET_UDEMY_COURSES:
      state = {
        ...state,
        isUdemyLoading: true,
        error: null,
      };
      break;

    case GET_UDEMY_COURSES_SUCCESS:
      state = {
        ...state,
        udemy: action.payload,
        isUdemyLoading: false,
      };
      break;

    case GET_UDEMY_COURSES_FAILURE:
      state = {
        ...state,
        isUdemyLoading: false,
        error: action.payload,
      };

    default:
      break;
  }
  return state;
}
